import { useState } from 'react';
import { useUpdateEffect } from './useUpdateEffect';
import automobyApi from '../Api';
 
export const useInvoice = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    order_by: "id",
    page: 1,
    
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/invoice/list", filter)
      setItems(response.data.invoices);
      setTotal(response.data.total);
      return response.data.invoices
    } catch (error) { 
      console.error("error:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/invoice/all", requestData)
      setItems(response.data.invoices);
      setTotal(response.data.total);
      return response.data.invoices
    } catch (error) {

      console.error("error:" + error);
    }
  }

  const add = (mobile, text) => {
    return new Promise(async (resolve, reject) => {
      try {
        const msg = {
          text: text,
          mobile: mobile, 
        };
  
        const response = await automobyApi.post(`/invoice/create`, msg);

        fetchList();
        resolve(response.data);
      } catch (error) {
        console.error(error);
        reject(error);
      }
    });
  }
  

  const search = async (invoice, count) => {
    try {
      const requestData = {
        invoice: invoice,
        count: count,
      };

      const response = await automobyApi.post("/invoice/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/invoice/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          invoice_id: id
        };
        const response = await automobyApi.post(`/invoice/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const updateLocal = async (invoice) => {
    setItems(items.map(item =>
      item.id === invoice.id ? invoice : item
    ));
  }
 

  const invoiceService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { invoiceService };
}